import { WGS84, DISTANCE_FORMAT } from "../libs/constants";
import { convertDeg, convertRad, convertToCartesian } from "../libs/helpers";
const getDistance = function (lat_long, format = "KM", precision = 2) {
    if (!lat_long || lat_long.length < 2) {
        throw TypeError("At least 2 points are needed to calculate the distance");
    }
    if (!DISTANCE_FORMAT[format.toUpperCase()]) {
        throw TypeError("Invalid output format");
    }
    const conversion = Number(DISTANCE_FORMAT[format.toUpperCase()]);
    const distance = [];
    let index = 0;
    while (index < lat_long.length - 1) {
        const { lat: lat1, long: long1 } = lat_long[index];
        const { lat: lat2, long: long2 } = lat_long[index + 1];
        const eqR = 6378.137;
        const pR = 6356.752;
        const avLat = convertRad((Number(lat1) + Number(lat2)) / 2);
        const radius = Math.sqrt((Math.pow((Math.pow(eqR, 2) * Math.cos(avLat)), 2) + Math.pow((Math.pow(pR, 2) * Math.sin(avLat)), 2)) /
            (Math.pow((eqR * Math.cos(avLat)), 2) + Math.pow((pR * Math.sin(avLat)), 2)));
        const phi1 = convertRad(Number(lat1));
        const phi2 = convertRad(Number(lat2));
        const delta_phi = convertRad(Number(lat2) - Number(lat1));
        const delta_lambda = convertRad(Number(long2) - Number(long1));
        const a = Math.pow(Math.sin(delta_phi / 2), 2) +
            Math.cos(phi1) * Math.cos(phi2) * Math.pow(Math.sin(delta_lambda / 2), 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        distance.push(radius * c * conversion);
        index += 1;
    }
    const totalDistance = distance.reduce((acc, prev) => acc + prev, 0);
    return {
        distance: Number(totalDistance.toFixed(precision)),
        format: format.toLowerCase(),
    };
};
const getCenterPoint = function (points) {
    if (!points) {
        throw TypeError("Input parameters missing");
    }
    const numberPoints = points.length;
    const { b, a, feSq, seSq } = WGS84;
    const sum = points.reduce((acc, point) => {
        const { X, Y, Z } = convertToCartesian(point);
        return {
            X: acc.X + X / numberPoints,
            Y: acc.Y + Y / numberPoints,
            Z: acc.Z + Z / numberPoints,
        };
    }, { X: 0, Y: 0, Z: 0 });
    const { X, Y, Z } = sum;
    const p = Math.sqrt(Math.pow(X, 2) + Math.pow(Y, 2));
    const R = Math.sqrt(Math.pow(p, 2) + Math.pow(Z, 2));
    const tanβ = ((b * Z) / (a * p)) * (1 + (seSq * b) / R);
    const sinβ = tanβ / Math.sqrt(1 + Math.pow(tanβ, 2));
    const cosβ = sinβ / tanβ;
    return {
        lat: convertDeg(Math.atan2(Z + seSq * b * Math.pow(sinβ, 3), p - feSq * a * Math.pow(cosβ, 3))).toFixed(5),
        long: convertDeg(Math.atan2(Y, X)).toFixed(5),
    };
};
const orderByDistance = function (origin, points, format = "KM") {
    if (!origin || !points) {
        throw TypeError('Input parameters missing');
    }
    const distances = [];
    points.map((point) => {
        const { distance } = getDistance([origin, point], format);
        distances.push({
            from: origin,
            to: point,
            distance: distance,
            format: format.toLowerCase(),
        });
    });
    return distances.sort((a, b) => a.distance - b.distance);
};
export { getDistance, getCenterPoint, orderByDistance };
//# sourceMappingURL=mapTools.js.map